import { useCallback, useMemo } from 'react';

import { usePersistentData } from '../usePersistentData';

const FEATURE_DATA_CONTEXT_KEY = 'ONBOARDING_ZIP_CODE';
const VERSION = '1';

interface OnboardingZipCodePersistentData {
  zipCode: string;
  isDeliverable?: boolean;
  latitude?: number;
  longitude?: number;
}

export function useOnboardingZipCodePersistentData() {
  const { data, setData, isLoading } = usePersistentData(`${FEATURE_DATA_CONTEXT_KEY}.${VERSION}`);

  const setOnboardingZipCodePersistentData = useCallback(
    (newContext: OnboardingZipCodePersistentData) => {
      setData(newContext);
    },
    [setData]
  );

  const memo = useMemo(() => (data ? (JSON.parse(data) as OnboardingZipCodePersistentData) : null), [data]);
  return {
    onboardingZipCodePersistentData: memo,
    setOnboardingZipCodePersistentData,
    isLoading,
  };
}
